import type { PriceAlertMetric } from "@/features/priceAlerts/PriceAlertMetric";

export type PriceAlertDescriptionType =
	| {
		type: "invalidTarget";
	} | {
		type: "beforeCreation";
	} | {
		type: "fixedValueThreshold";
		direction: "increases" | "decreases";
		comparator: "or less" | "or more";
	} | {
		type: "flatChange";
		direction: "increases" | "decreases";
	} | {
		type: "percentageChange";
		direction: "increases" | "decreases";
	};

export const getPriceAlertDescriptionType = (metricType: PriceAlertMetric, metric: number, currentValue: number | null): PriceAlertDescriptionType => {
	if (metricType === "FixedValue") {
		if (currentValue === null) {
			return {
				type: "beforeCreation"
			};
		}

		if (currentValue === metric) {
			return {
				type: "invalidTarget"
			};
		}

		return currentValue > metric
			? {
				type: "fixedValueThreshold",
				direction: "decreases",
				comparator: "or less"
			}
			: {
				type: "fixedValueThreshold",
				direction: "increases",
				comparator: "or more"
			};
	}

	if (metricType === "FlatGain" || metricType === "FlatLoss") {
		return {
			type: "flatChange",
			direction: metricType === "FlatGain" ? "increases" : "decreases"
		};
	}

	return {
		type: "percentageChange",
		direction: metricType === "PercentageGain" ? "increases" : "decreases"
	};
};
